/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Alert, Drawer, Spin, Tag } from "antd";
import WidgetTabs from "./WidgetTabs";
import { Button, Collapse, Tabs } from "antd";
import { formatUid } from "../../../utils";
import "./WidgetTableClicked.scss";
import { getListByUidArray } from "../../../api";
import MapPropsContext from "../MapPropsContext";
import { StyledButton } from "../../../styled-components/Button";
import StyledTableHeader from "../../../styled-components/StyledTableHeader";

const SERVICE_CODE_ARRAY = [
  { code: "05", name: "2G" },
  { code: "06", name: "2G" },
  { code: "15", name: "3G" },
  { code: "18", name: "4G" },
  { code: "19", name: "4G" },
  { code: "43", name: "5G" },
  { code: "45", name: "5G" },
];

const WidgetTableClicked = ({
  getTitle,
  objects,
  fetchUrl,
  getRowTitle,
  getRow,
  clsInfo,
  serviceInfo,
  closeButtonRef,
}) => {
  const { setClickedPointIconObjects } = useContext(MapPropsContext);

  const [detailObjects, setDetailObjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [countedServiceName, setCountedServiceName] = useState([]);
  const [countedClsName, setCountedClsNames] = useState([]);

  useEffect(() => {
    if (!fetchUrl) {
      setDetailObjects(objects);
    } else {
      const uidArray = objects.map(({ uid }) => uid);
      const jungon = objects.map(({ jungon }) => jungon);

      if (uidArray.length > 0) {
        const isJungon =
          uidArray.length === 1 && jungon.toString() === "Y" ? "Y" : "N";

        setIsLoading(true);

        getListByUidArray({
          relUrl: fetchUrl + "&isJungon=" + isJungon,
          uidArray,
        })
          .then(({ data }) => {
            setDetailObjects(data.data); // data(response)에서 data객체 참조
          })
          .catch((e) => {
            console.error(e); // 상탯값에 남기기
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  }, [objects]);

  const onClose = (sendGps) => {
    if (sendGps == "Y") {
      if (typeof window["closeTab"] == "function") {
        window["closeTab"]();
      } else {
        setDetailObjects([]); //핀들이 지워지지 않는 버전은 여기가 아마 다를거야. 여러버전 추적 비교 지시.
        setClickedPointIconObjects([]); //핀들이 지워지지 않는 버전은 여기가 아마 다를거야. 여러버전 추적 비교 지시.
      }
    } else {
      setDetailObjects([]); //핀들이 지워지지 않는 버전은 여기가 아마 다를거야. 여러버전 추적 비교 지시.
      setClickedPointIconObjects([]); //핀들이 지워지지 않는 버전은 여기가 아마 다를거야. 여러버전 추적 비교 지시.
    }
  };

  const onSendGps = useCallback(() => {
    if (typeof window["sendGps"] == "function") {
      window["sendGps"]();
    }
  }, []);

  useEffect(() => {
    if (detailObjects) {
      // 서비스별 개수
      const serviceCodes = detailObjects.map(
        ({ rds_svc_form_cd }) => rds_svc_form_cd
      );
      const serviceNameArray = serviceCodes.map((ref_code) => {
        return (
          SERVICE_CODE_ARRAY.filter(({ code }) => ref_code === code)
            // eslint-disable-next-line array-callback-return
            .map(({ code, name }) => {
              if (ref_code === code) return name;
            })
        );
      });
      const serviceNames = serviceNameArray.flat();

      const countedServiceName = serviceNames.reduce((allName, name) => {
        if (name in allName) {
          allName[name]++;
        } else {
          allName[name] = 1;
        }
        return allName;
      }, {});

      setCountedServiceName(countedServiceName);

      // 국종별 개수
      const clsNames = detailObjects.map(({ cls_name }) => cls_name);
      const countedClsNames = clsNames.reduce((allName, name) => {
        if (name in allName) {
          allName[name]++;
        } else {
          allName[name] = 1;
        }
        return allName;
      }, {});
      setCountedClsNames(countedClsNames);
    }
  }, [detailObjects]);

  return (
    <WidgetTabs>
      {objects.length > 0 && (
        <div>
          <StyledTableHeader>
            {getTitle(detailObjects)} {isLoading && <Spin size="small" />}
          </StyledTableHeader>
          <div
            style={{ maxHeight: 400, overflowY: "scroll" }}
            className={"widget-table-clicked-collapse"}
          >
            {!isLoading && detailObjects.length === 0 && (
              <Alert
                message={"조회결과가 없습니다."}
                type={"error"}
                style={{ margin: 4 }}
              />
            )}

            {serviceInfo &&
              Object.keys(countedServiceName).map((key, index) => {
                return (
                  <span style={{ paddingLeft: 8 }} key={index}>
                    {key}({countedServiceName[key]}){" "}
                  </span>
                );
              })}

            {clsInfo &&
              Object.keys(countedClsName).map((key, index) => {
                return (
                  <span style={{ paddingLeft: 8 }} key={index}>
                    {key}({countedClsName[key]}){" "}
                  </span>
                );
              })}

            {!isLoading && detailObjects.length > 0 && (
              <Collapse
                expandIconPosition="right"
                style={{ margin: 5 }}
                defaultActiveKey={[0]}
              >
                {detailObjects.map(({ uid, ...kwargs }, index) => (
                  <Collapse.Panel
                    key={index}
                    header={
                      <>
                        <Tag>{index + 1}</Tag>
                        {getRowTitle
                          ? getRowTitle({ uid, ...kwargs })
                          : formatUid(uid)}
                      </>
                    }
                  >
                    {getRow && getRow({ uid, ...kwargs })}
                  </Collapse.Panel>
                ))}
              </Collapse>
            )}
          </div>
          <StyledButton
            style={{ margin: 5 }}
            onClick={(e) => onClose(objects.map(({ sendGps }) => sendGps))}
            ref={closeButtonRef}
          >
            닫기
          </StyledButton>
          {fetchUrl && objects.map(({ sendGps }) => sendGps) == "Y" && (
            <StyledButton
              style={{ margin: 5 }}
              className={"widget-table-clicked-sendgps-r"}
              id={"btn_sendgps-r"}
              onClick={onSendGps}
            >
              현재위치 전송
            </StyledButton>
          )}
        </div>
      )}
    </WidgetTabs>
  );
};

export default WidgetTableClicked;
